import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { GameProvider } from "./contexts/GameContext";
import { ThemeProvider } from "./contexts/ThemeContext";

function AppInner() {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="fixed inset-0 bg-[#0a0a0f] flex items-center justify-center z-[99999]">
        <div className="flex flex-col items-center gap-4">
          <div className="relative w-16 h-16">
            <div className="absolute inset-0 rounded-full border-4 border-amber-400/20"></div>
            <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-amber-400 animate-spin"></div>
            <div className="absolute inset-2 flex items-center justify-center">
              <i className="ri-earth-line text-amber-400 text-2xl"></i>
            </div>
          </div>
          <p className="text-amber-400/70 text-sm font-medium tracking-widest animate-pulse">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
    </BrowserRouter>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <LanguageProvider>
          <AuthProvider>
            <GameProvider>
              <AppInner />
            </GameProvider>
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
